import React, { FC } from 'react';

import { NumericFontSize, Weight } from '../../util/styles/fluent9';
import Block from '../Block';
import Text from '../Text';

import { HeadingProps, HeadingSize } from './Heading.types';

const textSizes: Record<HeadingSize, NumericFontSize> = {
  1: 600,
  2: 600,
  3: 600,
  4: 600,
  5: 400,
  6: 300,
};

const fontWeights: Record<HeadingSize, Weight> = {
  1: 'bold',
  2: 'bold',
  3: 'bold',
  4: 'semibold',
  5: 'regular',
  6: 'regular',
};

/**
 * A `Heading` component renders text at different size/weight depending on the given level.
 *
 * Note that semantic heading level (H1...H6) as used by screenreader navigation is expressed
 * using the separate SemanticHeading component.
 */

const Heading: FC<HeadingProps> = (props) => {
  const { size, children } = props;

  const textSize = textSizes[size];
  const fontWeight = fontWeights[size];

  return (
    <Block textSize={textSize}>
      <Text weight={fontWeight}>{children}</Text>
    </Block>
  );
};

export default Heading;
